module.exports = __webpack_public_path__ + "img/id-card.a5e18abe.png";